/**
 * @ngInject
 */
export class BsPopoverBoundaryDirectiveController {
    constructor($element) {
        this.$element = $element;
    }
}
export function bsPopoverBoundaryDirective() {
    return {
        restrict: 'A',
        controller: BsPopoverBoundaryDirectiveController
    };
}
